(function() { window.GUID_6122f02a_da67_47f9_9e53_7111e1bd0e79 = { getGuid: function() { return "6122f02a-da67-47f9-9e53-7111e1bd0e79"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-barchart",
                        callback: (accordion, e) => {
                            var _a, _b, _c;
                            try {
                                const $shouldHideHiddenInput = accordion.$Container.find(`.ShouldHideWallSection`);
                                if ($shouldHideHiddenInput.length) {
                                    const shouldHide = $shouldHideHiddenInput.val() == "true";
                                    if (shouldHide) {
                                        accordion.$Container.hide();
                                    }
                                }
                                const hiddenStatFieldId = (_a = accordion.$Content
                                    .find(`#BarChartSectionStatFieldId-${accordion.ContentId}`)) === null || _a === void 0 ? void 0 : _a.val();
                                if (CS.Helper.isNullOrWhiteSpace(hiddenStatFieldId))
                                    return;
                                let datapoints = [];
                                const $hiddenDataListsInputs = accordion.$Content.find(`input[id*="BarChartSectionDatapointsList-${accordion.ContentId}"]`);
                                const $hiddenDataInput = accordion.$Content.find(`#BarChartSectionDatapoints-${accordion.ContentId}`);
                                if ($hiddenDataListsInputs.length) {
                                    $hiddenDataListsInputs.each((index, element) => {
                                        const hiddenData = $(element).val();
                                        const datapointsList = JSON.parse(hiddenData);
                                        datapoints = datapoints.concat(datapointsList);
                                    });
                                }
                                else if ($hiddenDataInput.length) {
                                    const hiddenData = (_b = accordion.$Content
                                        .find(`#BarChartSectionDatapoints-${accordion.ContentId}`)) === null || _b === void 0 ? void 0 : _b.val();
                                    datapoints = JSON.parse(hiddenData);
                                }
                                else {
                                    return;
                                }
                                const barColors = CS.Helper.DataVisualizationHelper.getStatColors({
                                    stat: hiddenStatFieldId,
                                    count: 1,
                                    includeBrightVariantIfCountIsOne: true,
                                });
                                let barFillColor = barColors[0];
                                let highlightedBarTextColor = barColors[1];
                                let barTextColorIfStacked = barColors[1];
                                let highlightedBarFillColor = barFillColor;
                                let stackedBarFillColor = barFillColor;
                                let stackedBarTextColorIfStacked = barTextColorIfStacked;
                                const hiddenStackedStatFieldId = (_c = accordion.$Content
                                    .find(`#BarChartSectionStackedStatFieldId-${accordion.ContentId}`)) === null || _c === void 0 ? void 0 : _c.val();
                                if (CS.Helper.isNullOrWhiteSpace(hiddenStackedStatFieldId) === false) {
                                    const stackedBarColors = CS.Helper.DataVisualizationHelper.getStatColors({
                                        stat: hiddenStackedStatFieldId,
                                        count: 1,
                                        includeBrightVariantIfCountIsOne: true,
                                    });
                                    stackedBarFillColor = `${stackedBarColors[0]}70`;
                                    stackedBarTextColorIfStacked = stackedBarColors[1];
                                }
                                const highlightedEntityBaseIds = [];
                                // const hiddenHighlightedEntityBaseIds = accordion.$Content
                                //   .find(
                                //     `#BarChartSectionHighlightedEntityBaseIds-${accordion.ContentId}`
                                //   )
                                //   ?.val();
                                // if (
                                //   !Helper.isNullOrWhiteSpace(hiddenHighlightedEntityBaseIds) &&
                                //   typeof hiddenHighlightedEntityBaseIds === "string"
                                // ) {
                                //   try {
                                //     // It is a comma separated list of entity base ids that we want to parse as an array
                                //     const highlightedEntityBaseIdsSplit =
                                //       hiddenHighlightedEntityBaseIds.split(",");
                                //     if (highlightedEntityBaseIdsSplit?.length) {
                                //       highlightedEntityBaseIdsSplit.forEach((id) => {
                                //         highlightedEntityBaseIds.push(Number(id));
                                //       });
                                //     }
                                //     barFillColor = `${barFillColor}50`;
                                //   } catch (error) {}
                                // }
                                const statFieldsThatShouldUseMinYValueForMin = [
                                    "Differential",
                                    "Score",
                                    "CompuSportRating",
                                    "EncounterOpponentsScore",
                                    "Average",
                                    "WinPercent",
                                ];
                                const statFieldsWithLegendWhenStacked = [
                                    "EncounterOpponentsScore",
                                    "Score",
                                ];
                                const legendsByStatFieldId = {
                                    EncounterOpponentsScore: [JSRess.RoundWins, JSRess.RoundLosses],
                                    Score: [JSRess.Score, JSRess.OpponentsScore],
                                };
                                const shouldDisplayLegendWhenStacked = statFieldsWithLegendWhenStacked.includes(hiddenStatFieldId);
                                const statFieldsThatArePercentages = ["WinPercent"];
                                const isPercentage = statFieldsThatArePercentages.includes(hiddenStatFieldId);
                                accordion.CustomData = {
                                    scrollableBarChart: null,
                                };
                                accordion.CustomData.scrollableBarChart =
                                    new CS.Controls.ScrollableBarChart({
                                        id: accordion.ContentId,
                                        statFieldId: hiddenStatFieldId,
                                        containerElementId: `BarChartSectionContainerElement-${accordion.ContentId}`,
                                        legendContainerElementId: `BarChartSectionLegendElement-${accordion.ContentId}`,
                                        datapoints,
                                        legends: shouldDisplayLegendWhenStacked
                                            ? legendsByStatFieldId[hiddenStatFieldId]
                                            : undefined,
                                        barFillColor: barFillColor,
                                        highlightedBarTextColor: highlightedBarTextColor,
                                        highlightedBarFillColor: highlightedBarFillColor,
                                        highlightedEntityBaseIds: highlightedEntityBaseIds,
                                        useMinYValueForMin: statFieldsThatShouldUseMinYValueForMin.includes(hiddenStatFieldId),
                                        isPercentage: isPercentage,
                                        stackedBarFillColor: stackedBarFillColor,
                                        stackedBarTextColorIfStacked: stackedBarTextColorIfStacked,
                                        barTextColorIfStacked: barTextColorIfStacked,
                                        //max: isPercentage ? 100 : undefined,
                                    });
                                accordion.CustomData.scrollableBarChart.init();
                            }
                            catch (error) {
                                console.error(error);
                            }
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
